var _circle, _line, _line2, _line3, _line4, _line5, _line6, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMindmap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#5d5b53",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 300,
    r: 40,
    fill: "#5d5b53"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 300,
    x2: 210,
    y2: 210
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 300,
    x2: 390,
    y2: 210
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 300,
    x2: 210,
    y2: 390
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 300,
    x2: 390,
    y2: 390
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 300,
    x2: 300,
    y2: 170
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 300,
    y1: 300,
    x2: 300,
    y2: 430
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 180,
    r: 30
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 180,
    r: 30
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 420,
    r: 30
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 420,
    r: 30
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 140,
    r: 25
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 460,
    r: 25
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMindmap);
export default __webpack_public_path__ + "static/media/mindmap.abe8a4619eb6d9608976899065e25588.svg";
export { ForwardRef as ReactComponent };